import { render, staticRenderFns } from "./VPrice.vue?vue&type=template&id=23e53946&scoped=true&"
import script from "./VPrice.vue?vue&type=script&lang=js&"
export * from "./VPrice.vue?vue&type=script&lang=js&"
import style0 from "./VPrice.vue?vue&type=style&index=0&id=23e53946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e53946",
  null
  
)

export default component.exports